import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";

//traer bloques de una temporada buscando por id de temporada
export const getLabMeasurementsByAmbient = async (ambientId, startDate) => {
  try { //por el momento trae los ultimos 20 registros de cada propiedad por ambiente
    //falta configurar para que traiga la data desde una fecha especifica

    const { data } = await _axios.get(`/api/labMeasurements/panelData/${ambientId}?startDate=${startDate}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateLabRecord = async (id, newVal) => {
  try {
    const { data } = await _axios.patch(`/api/labMeasurements/${id}`, { value: newVal });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteMeasurementById = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/labMeasurements/${id}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}